import { render, staticRenderFns } from "./AddressCreateUpdate2.vue?vue&type=template&id=40c4ca34&scoped=true&"
import script from "./AddressCreateUpdate2.vue?vue&type=script&lang=js&"
export * from "./AddressCreateUpdate2.vue?vue&type=script&lang=js&"
import style0 from "./AddressCreateUpdate2.vue?vue&type=style&index=0&id=40c4ca34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4ca34",
  null
  
)

export default component.exports